import { createFileRoute } from "@tanstack/react-router";
import { AuditLogTableColumns } from "@/components/audit-log/audit-log-meta";
import { SearchEngine } from "@/components/ui/shared/search-engine";
import SimpleTable from "@/components/ui/table";
import { useSimpleForm } from "@/hooks/use-simple-form";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import type { AuditLog } from "@/store/AuditLog";
import { useEffect } from "react";

export const Route = createFileRoute("/(dasboard)/audit-logs")({
  component: AuditLogPages,
});

function AuditLogPages() {
  const store = useAppStore();
  const { t } = useTranslate();

  const searchForm = useSimpleForm({
    keyword: "",
  });

  useEffect(() => {
    if (store.auth.session) {
      store.auditLog.fetch({});
    }
  }, [store.auth.session]);

  return (
    <>
      <header className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold"> {t("Audit logs")} </h2>
      </header>
      <div className="mt-4"></div>
      <SearchEngine
        form={searchForm}
        autoComplete={(values: any) => {
          store.auditLog.paginate(
            store.auditLog.items.filter(
              (auditLog: AuditLog) =>
                auditLog.user?.first_name
                  .toLowerCase()
                  .includes(values.keyword.toLowerCase()) ||
                auditLog.user?.last_name
                  .toLowerCase()
                  .includes(values.keyword.toLowerCase()) ||
                auditLog.resource_name
                  .toLowerCase()
                  .includes(values.keyword.toLowerCase())
            )
          );
        }}
        selects={[]}
        onSubmit={undefined}
      />
      <SimpleTable
        cellClass="px-2"
        headCellClass="px-2"
        items={store.auditLog.pagination.data}
        columns={AuditLogTableColumns({ store })}
      />
    </>
  );
}
